import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import {playSplitText, playFade} from '../common/help_functions';


export function initAnimationBlocksSection(element) {
    playFade('.title', true)
    playFade('.content-text')
}

function initInfoSlider() {

    let swiper2 = new Swiper(".slider-items", {
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        },
        speed: 1000,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            disableOnInteraction: false
        }
    });
}

export function initInfoBlocksSection() {
    initInfoSlider();
    initAnimationBlocksSection();
}